module.exports = __webpack_public_path__ + "media/auto_history/zmiana_wlasciciela-blue-bdc56ca2.svg";